import React from 'react';

import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';

import FieldRadioGroup from '../commons/FieldRadioGroup';

import { getCatalogValuesForRadio } from '../../utils/form';
import { cleanedValuesPersonData } from '../../utils/store';

const PersonType = ({
  onChange,
  isInsuredPerson,
}) => {
  const { setValues, values } = useFormikContext();
  const personType = useSelector((state) => state.catalogs.personType);
  const handleOnChange = (value) => {
    onChange(value);
    setValues({ ...cleanedValuesPersonData, samePerson: values.samePerson });
  };

  return (
    <div className="form-fields">
      <h3>
        {isInsuredPerson ? 'Datos iniciales del asegurado' : 'Datos iniciales del contratante'}
      </h3>
      <hr className="solid" />
      <FieldRadioGroup
        additionalAction={handleOnChange}
        inputLabel="Tipo de persona"
        required
        radios={getCatalogValuesForRadio(personType, 'name', 'id')}
        name="personType" />
    </div>
  );
};

PersonType.defaultProps = {
  onChange: () => { },
  isInsuredPerson: false,
};

PersonType.propTypes = {
  onChange: PropTypes.func,
  isInsuredPerson: PropTypes.bool,
};

export default PersonType;
